import { Component, Input, TemplateRef, ViewChild } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatDialog, MatDialogModule } from '@angular/material/dialog';
import { CellRendererParams } from 'app/shared/components/smart-grid/core/interfaces/cell-renderer.interface';

@Component({
  selector: 'app-temporary-passwords-actions',
  standalone: true,
  imports: [
    MatMenuModule,
    MatIconModule,
    MatButtonModule,
    MatDialogModule
  ],
  templateUrl: './temporary-passwords-actions.component.html',
  styleUrls: ['./temporary-passwords-actions.component.scss']
})
export class TemporaryPasswordsActionsComponent {
  @Input() params!: CellRendererParams<any>;

  @ViewChild('deleteDialog') deleteDialog!: TemplateRef<any>;
  @ViewChild('revokeDialog') revokeDialog!: TemplateRef<any>;

  constructor(private dialog: MatDialog) {}

  openDeleteDialog(element: any): void {
    const dialogRef = this.dialog.open(this.deleteDialog, {
      width: '400px',
      data: element
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.deletePassword(element);
      }
    });
  }

  openRevokeDialog(element: any): void {
    const dialogRef = this.dialog.open(this.revokeDialog, {
      width: '400px',
      data: element
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.revokePassword(element);
      }
    });
  }

  deletePassword(element: any): void {
    this.params.colDef?.cellRendererParams?.deletePassword(element);
  }

  revokePassword(element: any): void {
    this.params.colDef?.cellRendererParams?.revokePassword(element);
  }

  isExpired(expiresAt: string | Date | null | undefined): boolean {
    return this.params.colDef?.cellRendererParams?.isExpired(expiresAt);
  }
}
